import { useState, useEffect } from 'react';
import { _APIS } from 'apis';
import request from 'request';
import moment from 'moment';

const getCApolloConfig = (params: any) => request.get(_APIS.PRODUCT_PRICE.COMMON.C_HOLIDAYS, { params });

export const useGetHolidays = (valid: boolean) => {
  const [holidayEnum, setHolidayEnum] = useState<any[]>([]);

  const dateSort = (dates: any) => {
    return dates.sort((a: any, b: any) => {
      return moment((a?.time_range || [])[0]).valueOf() - moment((b?.time_range || [])[0]).valueOf();
    })
  }

  useEffect(() => {
    if (!valid) return;
    getCApolloConfig({}).then((res: any) => {
      setHolidayEnum(dateSort(res?.data || []));
    })
  }, [valid]);

  return {
    holidayEnum
  };
}